import styled from 'styled-components';
import { Tag } from '@tryhackme/thm-ui-components';

export const StyledTag = styled(Tag)`
  background: ${({ theme }) => theme.colors.statusTag.inProgress};
  border: none;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.info.main};
`;
